import React, { Component } from 'react'
import './index.scss'
import Header from '../Components/header/index.jsx'
import Advantage from './component/Advantage/index'
import Software from './component/Software/index'
import SlideShow from '../Components/slideshow/index'
import Footer from '../Components/Footer/index'
import ARVR from './component/ARVR/index'
import We from './component/We/index'
import Cooperation from './component/Cooperation/index'
import Hardware from './component/Hardware/index'
import { Link, Route, Redirect, Routes } from 'react-router-dom'

class index extends Component {
  render() {
    //   typeArea版心
    return (
      <div style={{ backgroundColor: '#f6f6f6', position: 'relative', width: '100%' }}>
        <Header></Header>
        <SlideShow />
        <Hardware />
        <Software />
        <Advantage />
        <ARVR />
        <We />
        <Cooperation />
        <Footer />
      </div>
    )
  }
}

index.propTypes = {}

export default index
